import React, { useEffect, useState } from 'react';
import {
  useParams, Link, ScrollRestoration,
} from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import {
  Nav, Tab, Button,
} from 'react-bootstrap5';
import CoachProfile from 'components/Common/Coaches/Views/Profile/Index';
import routes from 'app/routes';
import confirmWithoutCancel from 'components/new_ui/Alerts/confirmWithoutCancel';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Actions from './Actions';

export default function ChooseNewCoach() {
  const { programId } = useParams();

  const [loading, setLoading] = useState(false);
  const [coaches, setCoaches] = useState(null);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'Choose Coach',
    },
  ];

  const selectCoach = () => {
    setLoading(true);
    Actions.saveCoach(programId, selectedCoach.id, () => {
      setLoading(false);
      confirmWithoutCancel({
        text: 'Your new coach is successfully selected!',
        confirmButtonText: 'Go To Program',
      }, () => {
        document.location.href = routes.members.programs.show(programId);
      });
    });
  };

  useEffect(() => {
    Actions.loadCoaches(programId, (collection) => {
      setCoaches(collection);
    });
  }, []);

  useEffect(() => {
    if (selectedCoach === null && coaches && coaches.length > 0) {
      setSelectedCoach(coaches[0]);
    }
  }, [coaches]);

  if (coaches === null || selectedCoach === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <>
      <div className="content wallet">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Please Select Your New Coach</h1>
          <p>
            LeggUP’s diverse network allows you access to certified expert coaches.
            Our AI algorithm enhances coach recommendations, so that you can select the
            coach that best fits your needs.
          </p>
        </section>

        <section>
          <Tab.Container
            id="select-coach"
            defaultActiveKey={`coach-${selectedCoach.id}`}
          >
            <Nav fill justify variant="tabs" className="d-flex">
              {coaches.map((coach, index) => (
                <Nav.Item key={coach.id}>
                  <Nav.Link
                    eventKey={`coach-${coach.id}`}
                    onClick={() => setSelectedCoach(coach)}
                  >
                    <img src={coach.attributes.avatar_url} alt="" width="44" height="44" />
                    <div className="d-none d-lg-inline">
                      {coach.attributes.full_name}
                    </div>

                    {index === 0 && (
                    <span className="best-match-label">Best Match</span>
                    )}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>

            <Tab.Content>
              {coaches.map((coach) => (
                <Tab.Pane key={coach.id} eventKey={`coach-${coach.id}`} className="px-sm-4 px-xxl-5">
                  <CoachProfile coach={coach} />
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>

          <footer className="d-flex justify-content-between">
            <Link
              to={routes.members.programs.index}
              className={`btn btn-outline-primary ${loading && 'disabled'}`}
            >
              Cancel
            </Link>

            <Button
              onClick={() => selectCoach()}
              disabled={loading}
            >
              {loading && <LoadingPlaceholder placement="inline" text=" " />}
              OK
            </Button>
          </footer>

        </section>
      </div>
      <ScrollRestoration />
    </>
  );
}
